var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container testimonial" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h2", { staticClass: "heading-title" }, [
          _vm._v(_vm._s(_vm._f("trans")("st_public.Testmonial")))
        ])
      ])
    ]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-md-4" }, [
        _c("div", { staticClass: "feature" }, [
          _c("div", { staticClass: "review" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M12 4.59151L7.86075 3.96L6 0L4.13925 3.96L0 4.59151L2.99438 7.65749L2.28563 12L6 9.94876L9.71437 12L9.00562 7.65749L12 4.59151Z",
                    fill: "#FFD600"
                  }
                })
              ]
            ),
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M12 4.59151L7.86075 3.96L6 0L4.13925 3.96L0 4.59151L2.99438 7.65749L2.28563 12L6 9.94876L9.71437 12L9.00562 7.65749L12 4.59151Z",
                    fill: "#FFD600"
                  }
                })
              ]
            ),
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M12 4.59151L7.86075 3.96L6 0L4.13925 3.96L0 4.59151L2.99438 7.65749L2.28563 12L6 9.94876L9.71437 12L9.00562 7.65749L12 4.59151Z",
                    fill: "#FFD600"
                  }
                })
              ]
            ),
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M12 4.59151L7.86075 3.96L6 0L4.13925 3.96L0 4.59151L2.99438 7.65749L2.28563 12L6 9.94876L9.71437 12L9.00562 7.65749L12 4.59151Z",
                    fill: "#FFD600"
                  }
                })
              ]
            ),
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M12 4.59151L7.86075 3.96L6 0L4.13925 3.96L0 4.59151L2.99438 7.65749L2.28563 12L6 9.94876L9.71437 12L9.00562 7.65749L12 4.59151Z",
                    fill: "#FFD600"
                  }
                })
              ]
            )
          ]),
          _c("span", [
            _vm._v(
              _vm._s(
                _vm._f("trans")(
                  "st_public.new_testimonial_text_1 " + _vm.websiteName()
                )
              ) + "  "
            )
          ]),
          _c("div", { staticClass: "service" }, [
            _vm._v(
              _vm._s(_vm._f("trans")("st_public.new_testimonial_customer_1"))
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "col-12 col-md-4" }, [
        _c("div", { staticClass: "feature" }, [
          _c("div", { staticClass: "review" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M12 4.59151L7.86075 3.96L6 0L4.13925 3.96L0 4.59151L2.99438 7.65749L2.28563 12L6 9.94876L9.71437 12L9.00562 7.65749L12 4.59151Z",
                    fill: "#FFD600"
                  }
                })
              ]
            ),
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M12 4.59151L7.86075 3.96L6 0L4.13925 3.96L0 4.59151L2.99438 7.65749L2.28563 12L6 9.94876L9.71437 12L9.00562 7.65749L12 4.59151Z",
                    fill: "#FFD600"
                  }
                })
              ]
            ),
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M12 4.59151L7.86075 3.96L6 0L4.13925 3.96L0 4.59151L2.99438 7.65749L2.28563 12L6 9.94876L9.71437 12L9.00562 7.65749L12 4.59151Z",
                    fill: "#FFD600"
                  }
                })
              ]
            ),
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M12 4.59151L7.86075 3.96L6 0L4.13925 3.96L0 4.59151L2.99438 7.65749L2.28563 12L6 9.94876L9.71437 12L9.00562 7.65749L12 4.59151Z",
                    fill: "#FFD600"
                  }
                })
              ]
            ),
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M12 4.59151L7.86075 3.96L6 0L4.13925 3.96L0 4.59151L2.99438 7.65749L2.28563 12L6 9.94876L9.71437 12L9.00562 7.65749L12 4.59151Z",
                    fill: "#FFD600"
                  }
                })
              ]
            )
          ]),
          _c("span", [
            _vm._v(
              _vm._s(
                _vm._f("trans")(
                  "st_public.new_testimonial_text_2 " + _vm.websiteName()
                )
              ) + "  "
            )
          ]),
          _c("div", { staticClass: "service" }, [
            _vm._v(
              _vm._s(_vm._f("trans")("st_public.new_testimonial_customer_2"))
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "col-12 col-md-4" }, [
        _c("div", { staticClass: "feature" }, [
          _c("div", { staticClass: "review" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M12 4.59151L7.86075 3.96L6 0L4.13925 3.96L0 4.59151L2.99438 7.65749L2.28563 12L6 9.94876L9.71437 12L9.00562 7.65749L12 4.59151Z",
                    fill: "#FFD600"
                  }
                })
              ]
            ),
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M12 4.59151L7.86075 3.96L6 0L4.13925 3.96L0 4.59151L2.99438 7.65749L2.28563 12L6 9.94876L9.71437 12L9.00562 7.65749L12 4.59151Z",
                    fill: "#FFD600"
                  }
                })
              ]
            ),
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M12 4.59151L7.86075 3.96L6 0L4.13925 3.96L0 4.59151L2.99438 7.65749L2.28563 12L6 9.94876L9.71437 12L9.00562 7.65749L12 4.59151Z",
                    fill: "#FFD600"
                  }
                })
              ]
            ),
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M12 4.59151L7.86075 3.96L6 0L4.13925 3.96L0 4.59151L2.99438 7.65749L2.28563 12L6 9.94876L9.71437 12L9.00562 7.65749L12 4.59151Z",
                    fill: "#FFD600"
                  }
                })
              ]
            ),
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M12 4.59151L7.86075 3.96L6 0L4.13925 3.96L0 4.59151L2.99438 7.65749L2.28563 12L6 9.94876L9.71437 12L9.00562 7.65749L12 4.59151Z",
                    fill: "#FFD600"
                  }
                })
              ]
            )
          ]),
          _c("span", [
            _vm._v(
              _vm._s(
                _vm._f("trans")(
                  "st_public.new_testimonial_text_3 " + _vm.websiteName()
                )
              ) + "  "
            )
          ]),
          _c("div", { staticClass: "service" }, [
            _vm._v(
              _vm._s(_vm._f("trans")("st_public.new_testimonial_customer_3"))
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e86941d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e86941d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Testimonial.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e86941d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Testimonial.vue
// module chunks = 2 3 4 5 6 7 8